import { PageTemplate } from "@omni/types/enums/pageTemplate.enum";

import { Config } from "@/utils/config.utils";

export const isPageTemplate = (pageTemplate: PageTemplate) =>
    Config.general["page-template"] === pageTemplate;
